import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const hideAutoReplenishSelector = createSelector(testTargetOffersSelector, offers => offers.hideAutoReplenish || Empty.Object);

export { hideAutoReplenishSelector };
